enum LoyaltyAuthMethod {
  Barcode = 1,
  EmailPhoneNumber = 2,
  EmailPassword = 3,
  UsernamePassword = 4,
  PhoneNumber = 5,
  CardNumber = 6,
  Email = 7,
  WebSessionToken = 8,
  ManualRedemption = 9,
  Hid = 10,
}

export { LoyaltyAuthMethod };
